/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { PRODUCT_NORMALIZER } from '@spartacus/core';
import { CustomProductDataSheetConverter } from './product/product-datasheet.normalizer';

@NgModule({
  providers: [
    {
      provide: PRODUCT_NORMALIZER,
      useExisting: CustomProductDataSheetConverter,
      multi: true,
    },
  ],
})
export class CustomConverterModule {}
